import { Component, Input, signal } from '@angular/core';
import {
  GcButtonComponent,
  GcListComponent,
  GcListItemComponent,
  IpoClickOutsideDirective,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import {
  OptionsButtonData,
  OptionsButtons,
  OptionsButtonType,
} from '../../report-input-entities';
import { ReportInputsService } from '../../service/report-inputs.service';
import { ErrorPreventionModalComponent } from '../error-prevention-modal/error-prevention-modal.component';

@Component({
  selector: 'app-options-button',
  imports: [
    GcButtonComponent,
    GcListComponent,
    GcListItemComponent,
    IpoTranslatePipe,
    IpoClickOutsideDirective,
    ErrorPreventionModalComponent,
  ],
  templateUrl: './options-button.component.html',
  styleUrl: './options-button.component.scss',
})
export class OptionsButtonComponent {
  @Input() type?: OptionsButtonType = 'DEFAULT';
  @Input() isDone: boolean;
  @Input() id: string;
  @Input() mimeType?: string;
  @Input() disableUndo?: boolean;

  buttonData: OptionsButtonData[];

  showErrorPreventionModal = signal(false);

  showPopup = false;
  //This counter is needed becuase the click that opens the component will trigger the click outside directive.
  //That causes the compoennt to close emidietly as it opens
  //The counter prevents that from happening
  firstClick = true;

  constructor(private readonly reportInputsService: ReportInputsService) {}

  openPopup() {
    this.createButtonData();
    this.showPopup = true;
  }

  closePopup() {
    this.showPopup = false;
    this.firstClick = true;
  }

  itemClicked(fn: ($event?: Event) => any, $event?: Event) {
    fn($event);
    this.closePopup();
  }

  handleClickOutside() {
    if (!this.firstClick) {
      this.closePopup();
    } else {
      this.firstClick = false;
    }
  }

  errorPreventionProceed() {
    this.reportInputsService.setUndoSelfInspection(this.id);
    this.closeErrorPrevention();
  }

  errorPreventionCancel() {
    this.closeErrorPrevention();
  }

  openErrorPrevention() {
    this.showErrorPreventionModal.set(true);
  }

  closeErrorPrevention() {
    this.showErrorPreventionModal.set(false);
  }

  handleOnClickMarkAsNA() {
    this.reportInputsService.setIsEditModeValue(this.id, true);
  }

  handleOnClickEdit() {
    this.reportInputsService.setIsEditModeValue(this.id, true);
  }

  handleOnClickUploadFiles(event: Event) {
    this.reportInputsService.setUploadFiles(this.id, event);
  }

  handleOnClickUndo() {
    this.openErrorPrevention();
  }

  createButtonData() {
    this.buttonData = [
      {
        labelString: 'reportInput.optionsButton.markAsNA',
        iconName: 'diamondExclamation',
        showButton: this.showButton('MARK_AS_N/A'),
        clickedFn: this.handleOnClickMarkAsNA.bind(this),
      },
      {
        labelString: 'reportInput.optionsButton.editDescription',
        iconName: 'penToSquare',
        showButton: this.showButton('EDIT'),
        clickedFn: this.handleOnClickEdit.bind(this),
      },
      {
        labelString: 'reportInput.optionsButton.uploadImages',
        iconName: 'upload',
        showButton: this.showButton('UPLOAD'),
        clickedFn: this.handleOnClickUploadFiles.bind(this),
      },
      {
        labelString: 'reportInput.optionsButton.undo',
        iconName: 'reply',
        showButton: this.showButton('UNDO'),
        clickedFn: this.handleOnClickUndo.bind(this),
      },
    ];
  }

  showButton(type: OptionsButtons) {
    switch (type) {
      case 'MARK_AS_N/A':
        return !this.isDone;
      case 'EDIT':
        return this.isDone && this.type === 'N/A';
      case 'UPLOAD':
        return this.isDone && this.type === 'UPLOAD';
      case 'UNDO':
        return this.isDone && !this.disableUndo;
    }
  }
}
